import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.splide__seo-cards' ).length ) {
        $( '.splide__seo-cards' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 4,
            perMove: 1,
            start: 1,
            focus: 1,
            pagination: false,
            trimSpace: true,
            speed: 800,
            breakpoints: {
              1280: {
                perPage: 2,
                gap: '1rem',
              },
              768: {
                perPage: 1,
                gap: '1rem',
              },
            },
          } );
          slider.on( 'overflow', function( isOverflow ) {
            if ( !isOverflow ) {
              slider.options = {
                arrows: isOverflow,
                drag: isOverflow,
                clones: isOverflow ? undefined : 0,
              };
            }
          } );
          slider.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'seo-cards', COMPONENT );
} )( app );
